// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1TebS","productName":"Table_productName__159Ju"};